import React from 'react';

interface AuthenticationWarningProps {
  isUserAuthenticated: boolean;
}

export const AuthenticationWarning: React.FC<AuthenticationWarningProps> = ({
  isUserAuthenticated,
}) => {
  if (isUserAuthenticated) {
    return null;
  }

  return (
    <div className="mt-4 p-3 bg-yellow-50 border border-yellow-200 rounded-md">
      <p className="text-sm text-yellow-800">
        <strong>Hinweis:</strong> Sie müssen angemeldet sein, um Aktionen
        durchführen zu können.
      </p>
    </div>
  );
};
